import { useQuery } from "@tanstack/react-query";
import { UseFormReturn } from "react-hook-form";

import shelfCore from "../../core/shelf.core";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { FancySelect } from "../reuseables/form.comp";

interface ShelfProps {
  methods: UseFormReturn<{ shelfId: string }, any>;
}

export default function ProductShelfSelector({ methods }: ShelfProps) {
  return (
    <div id="shelves-list">
      <ShelfDetails methods={methods} />
    </div>
  );
}

function useShelves() {
  return useQuery({
    queryKey: ["shelves"],
    queryFn: shelfCore.listShelves,
  });
}

interface ShelfDetailsProps {
  methods: UseFormReturn<{ shelfId: string }, any>;
}

function ShelfDetails({ methods }: ShelfDetailsProps) {
  const { data: shelves, isLoading, error, isError } = useShelves();

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;

  const options = [
    { label: "", value: "" },
    ...(shelves || []).map((shelf) => ({
      label: shelf.name,
      value: shelf.id,
    })),
  ];

  return (
    <div className="">
      <FancySelect register={methods.register} fieldName="shelfId" options={options} />
    </div>
  );
}
